import axios from "axios";

const instance = axios.create({
  baseURL: "https://api.ozparts.eu",
});

export const getSlides = () => instance.get("/slider/brakes-pl");
